import useFetch from "../../hooks/useFetch";
import { useStoreState } from "../store/useStore";

export type AccountMode =
  | "ACCOUNT_LEVEL_NORMAL"
  | "ACCOUNT_LEVEL_SPOT"
  | "ACCOUNT_LEVEL_SPOT_FUTURES"
  | "ACCOUNT_LEVEL_MULTI_CURRENCY";

export type UpgradeState = "INIT" | "PROCESSING" | "FINISH";

export type getAccountUpgradeStateResponse = {
  upgrade_state: UpgradeState;
};

export type SetAccountModeParams = {
  type: "UPGRADE" | "SWITCH";
  new_account_level?: AccountMode;
};

export type GetAccountModeResponse = {
  account_level: AccountMode;
};

/**
 * 新用户任务过期信息返回类型
 */
export type NewUserTaskExpiredInfo = {
  /** 是否已领取 token splash 新用户任务 - web端assets小窗使用 */
  accepted_token_splash_new_user: boolean;
  /** 挑战任务是否过期，true过期，false未过期 */
  challenge_task_expired: boolean;
  /** 挑战任务最高奖励 - app首页assets下的字段 */
  challenge_task_max_reward_amount: string;
  /** 新人任务过期时间 */
  expired_time: number;
  /** 新人任务是否过期，true过期，false未过期 */
  new_user_task_expired: boolean;
  /** 新用户任务盲盒总奖励 - app首页assets下的字段 */
  new_user_task_reward_amount: string;
  /** rewards hub任务总奖励 */
  total_reward_amount: string;
  /** 交易任务数量 */
  trade_task_amount: string;
  /** 交易任务是否完成 */
  trade_task_finish_status: boolean;
  /** 交易任务奖励金额 */
  trade_task_reward_amount: string;
  /** 划转任务数量 */
  transfer_task_amount: string;
  /** 划转任务是否完成 */
  transfer_task_finish_status: boolean;
  /** 划转任务奖励金额 */
  transfer_task_reward_amount: string;
  /** 划转任务是否领取奖励 */
  transfer_task_reward_status: boolean;
  /** 挑战任务是否过期，true过期，false未过期 */
  challenge_task_time_expired: boolean;
};

const useAction = () => {
  const { baseUrl } = useStoreState();

  const { post, get } = useFetch(baseUrl);

  const getAccountMode = async <T>() => {
    return post<T>(`uapi/v1/uc/account_level/query`);
  };

  const getUserAsset = async <T>() => {
    return get<T>("uapi/v1/account/overview?quote_currency=USDT");
  };

  const getExchangeRate = async <T>() => {
    return post<T>("sapi/v1/exchange_rate/rates");
  };

  /**
   * 获取新用户任务过期信息
   * @param params
   * @returns
   */
  const getNewUserTaskExpiredInfo = async <T>(params?: { referral_code?: string }) => {
    const queryParams = new URLSearchParams(params).toString();
    return get<T>(
      `uapi/v1/task_center/new_user_task/expired/info${queryParams ? `?${queryParams}` : ""}`
    );
  };

  return {
    getAccountMode,
    getUserAsset,
    getExchangeRate,
    getNewUserTaskExpiredInfo
  };
};

export default useAction;
